<template>
  <div>
    <b-form-input type="password"
                  :state="passwordState"
                  :class="[mInput && 'm-input']"
                  v-model="mutableValue"
                  :placeholder="placeholder"
                  autocomplete="password"
                  @input="$emit('input', $event)"
                  aria-describedby="passwordFeedback">
    </b-form-input>
    <b-form-invalid-feedback id="passwordFeedback">
      {{ passwordFeedbackText }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
  export default {
    name: "PasswordInput",
    props: {
      value: String,
      placeholder: String,
      mInput: Boolean,
    },
    data() {
      return {
        mutableValue: this.value
      }
    },
    computed: {
      passwordState() {
        if (this.mutableValue.length === 0) {
          return null;
        }

        return !(this.mutableValue.length < 8
          || !this.mutableValue.match(/[0-9]/)
          || !this.mutableValue.match(/[a-z]/)
          || !this.mutableValue.match(/[A-Z]/));
      },
      passwordFeedbackText() {
        if (this.mutableValue.length < 8) {
          return this.$t('Password contain 8 characters')
        }

        if (!this.mutableValue.match(/[0-9]/)) {
          return this.$t('Password contain one number')
        }

        if (!this.mutableValue.match(/[a-z]/)) {
          return this.$t('Password contain small letter')
        }

        if (!this.mutableValue.match(/[A-Z]/)) {
          return this.$t('Password contain big letter')
        }
      }
    },
    watch: {
      mutableValue() {
        if (this.passwordState === true) {
          this.$emit('valid')
        } else {
          this.$emit('invalid')
        }
      },
      value(v) {
        this.mutableValue = v;
      }
    }
  }
</script>

<style scoped>

</style>
